import ApiService from '../base/BaseApiService';

export const fetchDocumentTypes = async () => {
  try {
    // 文書種別マスタ（管理者の権限設定で使用）
    return await ApiService.get('/document-types/');
  } catch (error) {
    console.error('Error fetching document types:', error);
    throw error;
  }
};

export const fetchDocumentTypesAccess = async () => {
  try {
    // 権限に応じたアクセス可能な文書種別のみ取得
    return await ApiService.get('/document-types/access');
  } catch (error) {
    console.error('Error fetching document type access:', error);
    throw error;
  }
};

export default {
  fetchDocumentTypes,
  fetchDocumentTypesAccess
};
